import Component from 'can/component/component';
import template from './win-probability.stache';
import FeedService from 'scripts/services/base-feed-service';
import {
    getFieldName,
    MAKE_CUT_PROBABILITY,
    TOP_10_PROBABILITY,
    WIN_PROBABILITY,
} from 'components/probability/types';
import can from 'can';
import _ from 'lodash';
import Swiper from 'swiper';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'card-win-probability',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            playerProfileLink: {
                get() {
                    return can.sub(window.globalSettings.pagePaths.player, {
                        playerId: this.attr('player.player.identifier'),
                    });
                },
            },
            fullFieldLink: {
                get() {
                    return (
                        window.globalSettings.pagePaths.playerStatistics +
                        '#!&win-probability=' +
                        this.attr('round')
                    );
                },
            },
            player: {
                type: 'object',
            },
            probabilityTypes: {
                type: 'array',
                value: [],
            },
            probabilityType: {
                type: 'string',
                value: '',
            },
            isNavOpen: {
                type: 'boolean',
                value: false,
            },
            standings: {
                type: 'array',
                value: [],
            },
            activeId: {
                type: 'string',
                value: null,
            },
            startHole: {
                get() {
                    const round = this.attr('round');
                    let start = 1;
                    if (round) {
                        start = this.attr(
                            `player.roundsInfo.${round -
                                1}.scorecard.holeResults.0.hole.identifier`,
                        );
                    }
                    return start;
                },
            },
            probabilities: {
                get() {
                    return this.attr('player.probability');
                },
            },
        },

        clickPlayerProfileLink(event) {
            event.preventDefault();
            const activePlayer = this.attr('player.player');
            dtm.trackPlayerProfileClick(
                activePlayer.firstName + ' ' + activePlayer.lastName,
                'Latest Probability',
            );
            window.open(this.attr('playerProfileLink'));
        },

        clickFullFieldLink(event) {
            event.preventDefault();
            dtm.trackWinProbabilityFullFieldClick();
            window.open(this.attr('fullFieldLink'));
        },

        getProbabilityTypeLabel(type) {
            switch (type) {
                case MAKE_CUT_PROBABILITY: {
                    return 'Make Cut Probability';
                }
                case TOP_10_PROBABILITY: {
                    return 'Top 10 Probability';
                }
                default: {
                    return type;
                }
            }
        },
        getProbabilityTypeText(probabilityType) {
            switch (probabilityType) {
                case WIN_PROBABILITY:
                case MAKE_CUT_PROBABILITY:
                case TOP_10_PROBABILITY: {
                    return 'Top 5 Players';
                }
            }
        },
        changeProbabilityType(probabilityType) {
            this.attr('isNavOpen', false);
            this.attr('probabilityType', probabilityType);
            dtm.trackLatestWinProbabilityTrackerTabClick(probabilityType);
        },
        toggleNavOpen() {
            this.attr('isNavOpen', !this.attr('isNavOpen'));
        },
        setActiveId(playerId) {
            if (this.attr('activeId') === playerId) {
                this.attr('activeId', null);
                return;
            }

            this.attr('activeId', playerId);
        },
    },
    events: {
        onLayout(screen) {
            this.initSwiper();
        },

        initSwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            this.swiper = new Swiper($('.swiper'), {
                slidesPerView: 2.3,
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2.3,
                        allowTouchMove: true,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 3.3,
                        allowTouchMove: true,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 4.3,
                        allowTouchMove: true,
                    },
                    1023: {
                        slidesPerView: 5,
                        allowTouchMove: false,
                    },
                },
                edgeSwipeThreshold: 30,
                speed: 1000,
                on: {
                    observerUpdate: () => this.updateSwiperSize(),
                },
            });
        },
        updateSwiperSize() {
            if (!this.swiper || !this.swiper.scrollbar) {
                return;
            }

            this.swiper.update();
            this.swiper.scrollbar.updateSize();
        },
        inserted() {
            const biggestMoversFeedUrl =
                window.globalSettings.feeds.biggestMoversUrl;

            this.updateProbabilityTypes();

            this.viewModel.bind('round', () => {
                this.updateProbabilityTypes();
            });

            const compute = can.compute(() => ({
                makeCutRounds: this.viewModel.attr('makeCut'),
                top10Rounds: this.viewModel.attr('top10'),
                winProbabilityRounds: this.viewModel.attr('win'),
                probabilityType: this.viewModel.attr('probabilityType'),
            }));

            compute.bind('change', (__, vm) => {
                if (!vm.probabilityType) {
                    const firstCameData =
                        vm.makeCutRounds ||
                        vm.winProbabilityRounds ||
                        vm.top10Rounds;

                    this.viewModel.attr(
                        'probabilityType',
                        firstCameData.currentRound > 2
                            ? WIN_PROBABILITY
                            : MAKE_CUT_PROBABILITY,
                    );

                    return;
                }

                const data = vm[getFieldName(vm.probabilityType)];

                if (!data) {
                    return;
                }

                this.viewModel.attr('standings', data.players);
                this.viewModel.attr('round', data.currentRound);

                if (!this.viewModel.attr('activeId')) {
                    this.viewModel.attr(
                        'activeId',
                        data.players[0].player.identifier,
                    );
                }

                this.initSwiper();
            });

            this.navListener = (event) => {
                const nav = document.getElementById('wp-nav');

                if (nav && !nav.contains(event.target)) {
                    this.viewModel.attr('isNavOpen', false);
                }
            };

            document.addEventListener('mousedown', this.navListener);

            this.makeCutFeed = new FeedService({
                feedUrl: can.sub(biggestMoversFeedUrl, { filter: 'makeCut' }),
                fromCache: false,
                autoUpdate: true,
            });
            this.top10Feed = new FeedService({
                feedUrl: can.sub(biggestMoversFeedUrl, { filter: 'top10' }),
                fromCache: false,
                autoUpdate: true,
            });
            this.winProbabilityFeed = new FeedService({
                feedUrl: can.sub(biggestMoversFeedUrl, { filter: 'win' }),
                fromCache: false,
                autoUpdate: true,
            });

            this.makeCutFeed.on('data', (ev, data) => {
                this.viewModel.attr('makeCut', data);
            });
            this.winProbabilityFeed
                .on('fetching', (ev, value) =>
                    this.viewModel.attr('fetching', value),
                )
                .on('data', (ev, data) => {
                    this.viewModel.attr('win', data);
                });
            this.top10Feed.on('data', (ev, data) => {
                this.viewModel.attr('top10', data);
            });
            this.makeCutFeed.fetch();
            this.top10Feed.fetch();
            this.winProbabilityFeed.fetch();

            const currentPlayerCompute = can.compute(() => ({
                standings: this.viewModel.attr('standings'),
                activeId: this.viewModel.attr('activeId'),
            }));

            currentPlayerCompute.bind('change', (__, value) => {
                this.viewModel.attr(
                    'player',
                    _.find(
                        value.standings,
                        (it) => it.player.identifier === value.activeId,
                    ),
                );
            });
        },
        updateProbabilityTypes() {
            const round = this.viewModel.attr('round');
            const probabilityType = this.viewModel.attr('probabilityType');
            const baseTypes = [
                MAKE_CUT_PROBABILITY,
                WIN_PROBABILITY,
                TOP_10_PROBABILITY,
            ];
            const mapTypes = (type) => ({
                type,
                active: probabilityType === type,
            });

            if (round === 0) {
                this.viewModel.attr(
                    'probabilityTypes',
                    baseTypes.map(mapTypes),
                );
                return;
            }

            const types = baseTypes
                .filter((type) => type !== MAKE_CUT_PROBABILITY || round <= 2)
                .map(mapTypes);

            this.viewModel.attr('probabilityTypes', types);
        },
        destroy() {
            document.removeEventListener('mousedown', this.navListener);
        },
    },
});
